import { type ComponentPropsWithoutRef, type FC } from 'react';
import { cn } from '../lib/utils';
import { InputGroup, InputGroupAddon, InputGroupInput, InputGroupText } from './InputGroup';

type NumberInputGroupProps = Omit<
  ComponentPropsWithoutRef<typeof InputGroup>,
  'value' | 'onChange'
> & {
  placeholder?: string;
  prefix?: string;
  suffix?: string;
  max?: number;
  min?: number;
  step?: number | string;
  value?: number;
  onChange: (value: number) => void;
};

export const NumberInputGroup: FC<NumberInputGroupProps> = (props) => {
  const { className, max, min, step, placeholder, prefix, suffix, value, onChange } = props;

  const inputGroupAddon = (val?: string, isSuffix?: boolean) => {
    if (val) {
      return (
        <InputGroupAddon align={isSuffix ? 'inline-end' : 'inline-start'}>
          <InputGroupText>{val}</InputGroupText>
        </InputGroupAddon>
      );
    }
  };
  return (
    <InputGroup
      className={cn(
        'text-text-primary has-[[data-slot=input-group-control]:focus-visible]:border-teal-500 has-[[data-slot=input-group-control]:focus-visible]:ring-[3px] has-[[data-slot=input-group-control]:focus-visible]:ring-teal-500/50',
        suffix &&
          '[&_[data-align=inline-end]>span]:font-normal [&_[data-align=inline-end]>span]:text-text-secondary',
        '[&_[data-slot=input-group-control]]:placeholder:font-normal [&_[data-slot=input-group-control]]:placeholder:text-text-secondary',
        className,
      )}
    >
      {inputGroupAddon(prefix)}
      <InputGroupInput
        type="number"
        value={value}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      {inputGroupAddon(suffix, true)}
    </InputGroup>
  );
};
